<button disabled mat-mini-fab [ngClass]=" total < 999 ?  bgColor + ' medium' : bgColor + ' small'">{{total}}</button>